export type StreamingTechnologiesData = {
  none: boolean;
  icecast: boolean;
  shoutcast_cast: boolean;
  other: boolean;
  others: string;
};

export type StreamTypesData = {
  aac: boolean;
  mp3: boolean;
  mp3u: boolean;
  m3ub: boolean;
  other: boolean;
  others: string;
};

export type CurrentStreamAndEquipmentData = {
  currentStreamURL: string;
  bitrate: string;
  averageSimultaneousUsers: string;
};

export type StreamConfigurationFormData = {
  streamingTechnologies: StreamingTechnologiesData;
  streamTypes: StreamTypesData;
  currentStreamAndEquipment: CurrentStreamAndEquipmentData;
};

export type StreamConfigurationFormSection = StreamingTechnologiesData | StreamTypesData | CurrentStreamAndEquipmentData;

export const INITIAL_DATA = {
  streamingTechnologies: {
    none: false,
    icecast: false,
    shoutcast_cast: false,
    other: false,
    others: '',
  },

  streamTypes: {
    aac: false,
    mp3: false,
    mp3u: false,
    m3ub: false,
    other: false,
    others: '',
  },

  currentStreamAndEquipment: {
    currentStreamURL: '',
    bitrate: '',
    averageSimultaneousUsers: '',
  },
};



// WEBPACK FOOTER //
// ./src/statsradio/modules/radioConfiguration/domain/StreamConfiguration.js